<template>
  <div class="row mt-3">
    <div class="col-sm-12 col-md-6">
      <div id="tickets-table_length" class="dataTables_length">
        <label class="d-inline-flex align-items-center">
          {{ $t('global.text.displays') }}
          <b-form-select
            class="form-select form-select-sm"
            v-model="page"
            size="sm"
            :options="pageOptions"
            @change="changePerPage"
          >
          </b-form-select>
          {{ $t('global.text.entries') }}.
          <p>
            {{ $t('global.text.display') }}
            <strong>{{ filteredItems > 0 ? (pageNumber - 1) * page + 1 : 0 }}</strong>
            - <strong>{{ Math.min(filteredItems, pageNumber * page) }}</strong>
            {{ $t('global.object.of') }}
            <strong>{{ filteredItems }}</strong>
          </p>
        </label>
      </div>
    </div>
    <div class="col-sm-12 col-md-6">
      <div class="dataTables_paginate paging_simple_numbers float-end">
        <ul class="pagination pagination-rounded mb-0">
          <!-- pagination -->
          <b-pagination
            v-model="pageNumber"
            :total-rows="totalRows == null ? rows : totalRows"
            :per-page="page"
            @change="changeCurrentPage"
          ></b-pagination>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
    },
    perPage: {
      type: Number,
    },
    pageOptions: {
      type: Array,
    },
    filteredItems: {
      type: Number,
    },
    totalRows: {
      type: Number,
    },
    rows: {
      type: Number,
    },
  },
  data() {
    return {
      page: this.perPage,
      pageNumber: this.currentPage,
    }
  },
  methods: {
    changeCurrentPage(value) {
      this.$emit('currentPagePage', value)
    },

    changePerPage(value) {
      this.$emit('newPerPage', value)
    },
  },
}
</script>
